use '@use-gpu/wgsl/display/depth'::{ displayDepth };

@link fn loadColor(xy: vec2<u32>) -> vec4<f32>;
@link fn loadRevealage(xy: vec2<u32>) -> f32;

@link fn getSize() -> vec2<f32>;

const EPS = 1e-6;

@export fn getOITResolve(targetUV: vec2<f32>) -> vec4<f32> {

  let sampleXY = targetUV * getSize();
  let xy = vec2<u32>(sampleXY);

  let color = loadColor(xy);
  let revealage = loadRevealage(xy);

  return vec4<f32>(
    color.rgb / clamp(color.a, 1e-4, 5e4),
    1.0 - revealage.r
  );
}
